import { Component, OnInit } from '@angular/core';
declare var jQuery: any;

@Component({
  selector: 'app-web-developer-portfolio',
  templateUrl: './web-developer-portfolio.component.html',
  styleUrls: ['./web-developer-portfolio.component.scss']
})
export class WebDeveloperPortfolioComponent implements OnInit {

  profile: any = {
    logo: "logo-black-5.png",
    profile: "web-developer"
  };

  page_banner: any = {
    title: "Portfolio",
    profile: "web-developer",
  };

  categories: any = [
    {
      title: "Mobile App",
      filter_title: "mobile",
    },
    {
      title: "Web App",
      filter_title: "web",
    },
  ];

  portfolios: any = [
    {
      title: "Attila V2",
      description: "Household planner and a Checkist Manager",
      image: "LogoAttilaV2.png",
      src_image: "main-pic1.jpg",
      link: "https://codeattila.ch",
      frontEnd: {
        github: "https://github.com/rebeb74/ng-attila-client-v2",
        technologies: ["Angular 11", "RXJS", "NGRX (Store, Effects and Data)", "Angular Material", "Socket.IO"],
        features: ["Calendar", "Checklists", "Multilingual", "Notifications", "Real-time communication"]
      },
      backEnd: {
        github: "https://github.com/rebeb74/ng-attila-srv-v2",
        technologies: ["NodeJS", "ExpressJS", "MongoDB", "Socket.IO"],
        features: ["Authentication JWT", "NodeMailer", "Real-Time Communication", "Mongoose Database"]
      }
    },
    {
      title: "Attila V1",
      description: "Household planner and a List Manager",
      image: "LogoAttila.jpg",
      src_image: "main-pic1.jpg",
      link: "https://v1.codeattila.ch",
      frontEnd: {
        github: "https://github.com/rebeb74/attila-client",
        technologies: ["Angular 10", "Ionic 5"],
        features: ["Calendar", "Lists"]
      },
      backEnd: {
        github: "https://github.com/rebeb74/attila-srv",
        technologies: ["NodeJS", "ExpressJS", "MongoDB"],
        features: ["Authentication JWT", "Mongoose Database"]
      }
    },
    {
      title: "IZIprint",
      description: "Website for an advertising company",
      image: "logo iziprint.png",
      src_image: "main-pic1.jpg",
      link: "https://iziprint.bertrandpetit.ch",
      frontEnd: {
        github: "https://github.com/rebeb74/laravue-IZIprint/tree/main/resources/js",
        technologies: ["VueJS 3", "TailwindCss"],
        features: ["Showcase", "Administration", "SEO", "Galleries"]
      },
      backEnd: {
        github: "https://github.com/rebeb74/laravue-IZIprint",
        technologies: ["PhP", "Laravel", "MySQL"],
        features: ["Authentication Laravel Sanctum", "Image Uploads"]
      }
    }
  ]

  constructor() { }

  ngOnInit(): void {
    (function ($) {

      setTimeout(function () {
        var self = jQuery("#masonry, .masonry");
        if (jQuery('.card-container').length) {
          self.imagesLoaded(function () {
            self.masonry({
              gutterWidth: 15,
              isAnimated: true,
              itemSelector: ".card-container"
            });
          });
        }

        jQuery(".filters").on('click', 'li', function (e) {

          var filter = jQuery(this).attr("data-filter");
          self.masonryFilter({
            filter: function () {
              if (!filter) return true;
              return jQuery(this).hasClass(filter);
            }
          });
        });
      }, 500);


    })(jQuery);

  }

}
